import { useQuery } from '@tanstack/react-query';
import { SectorComercial, UnidadNegocio } from '../../../../../types';
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion';


export const useNOTESUnidadNegocio = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: unidadNegocio = [],
    isLoading,
    isError,
    error
  } = useQuery<UnidadNegocio[], Error>({
    queryKey: ['NOTES-unidad-negocio', codPais, codSistema],
    queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
    enabled: !!codPais && !!codSistema
  })

  return {
    unidadNegocio,
    isLoading,
    isError,
    error
  }
}


export const useNOTESSectorComercialTipos = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: sectorComercialTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<SectorComercial[], Error>({
    queryKey: ['NOTES-sector-comercial-tipos', codUnidadNegocio, codSistema],
    queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
    enabled: !!codUnidadNegocio && !!codSistema
  })

  return {
    sectorComercialTipos,
    isLoading,
    isError,
    error
  }
}
